export default {
    getlg(col, cols) {

        let colsCount = 0
        for(let col in cols) {
            if (cols[col].show === undefined ||cols[col].show === true) {
                colsCount = colsCount + 1
            }
        }

        let lg = 12 / colsCount
        if (lg < 2) {
            lg = 2
        }
        if (col.lg !== undefined) {
            lg = col.lg
        }
        return lg
    },
    isMobile(maxScreenWidth) {
        if (maxScreenWidth === undefined) {
            maxScreenWidth = 500
        }
        if (navigator.userAgent.match(/Android/i) || navigator.userAgent.match(/webOS/i) || navigator.userAgent.match(/iPhone/i) || navigator.userAgent.match(/iPad/i) || navigator.userAgent.match(/iPod/i) || navigator.userAgent.match(/BlackBerry/i) || navigator.userAgent.match(/Windows Phone/i)) {
            return true
        } else {
            var screenWidth = window.innerWidth || document.body.clientWidth
            if (screenWidth < maxScreenWidth) {
                return true
            }
            return false
        }
    }
}